import { getField, updateField } from 'vuex-map-fields';
import { client } from "@/api/client";

export const SET_CONTRACT_TYPES = "SET_CONTRACT_TYPES";
export const SET_SERVICE_PLAN = "SET_SERVICE_PLAN";
export const SET_PROMOTIONAL_CODE = 'SET_PROMOTIONAL_CODE';

const state = () => ({
    contract_types: [],
    service_plan: undefined,
    promotional_code:undefined
});

const getters = {
    getField,
}

const mutations = {
    updateField,
    [SET_CONTRACT_TYPES](state, contract_types) {
        state.contract_types = contract_types;
    },
    [SET_SERVICE_PLAN](state, service_plan) {
        state.service_plan = service_plan
    },
    [SET_PROMOTIONAL_CODE](state, promotional_code) {
        state.promotional_code = promotional_code;
    }
}

const getContractTypes = ({ commit, state, dispatch }) => {
    return new Promise((resolve, reject) => {
        client.get('contract_types/').then(response => {
            commit(SET_CONTRACT_TYPES, response.data.results.filter(
                item => item.is_tpv_payable == true
            ));
            resolve();
        }).catch(err=>{
            console.debug(err)
            reject();
        });

    });
}

const setServicePlan = ({ commit }, service_plan) => {
    commit(SET_SERVICE_PLAN, service_plan)
}

const setPromotionalCode = ({ commit }, promotional_code) => {
    commit(SET_PROMOTIONAL_CODE, promotional_code);
}

const createContract = ({ state }) => {
    return new Promise((resolve, reject) => {
        let params = {
            'contract_type_id': state.service_plan
        }
        if (state.promotional_code) {
            params['promotional_code'] = state.promotional_code;
        }
        client.post('create_contract/', params).then(resp => {
            resolve(resp.data);
        }).catch(err => {
            console.debug(err);
            reject();
        });
    });
}

const upgradeContract = ({ state }) => {
    return new Promise((resolve, reject) => {
        client.post('upgrade_contract/', { 'contract_type_id': state.service_plan }).then(() => {
            resolve();
        }).catch(err => {
            console.debug(err);
            reject();
        });
    });
}

const upgradeTrialContract = ({ state }) => {
    return new Promise((resolve, reject) => {
        client.post('upgrade_trial_contract/', { 'contract_type_id': state.service_plan }).then((response) => {
            resolve(response.data);
        }).catch(err => {
            console.debug(err);
            reject();
        });
    });
}

const isTransactionOk = ({}, contract_id) => {
    return new Promise((resolve, reject) => {
        client.post('is_transaction_ok/', { 'contract_id': contract_id }).then(response => {
            resolve(response);
        }).catch(err => {
            console.debug(err);
            reject();
        });
    });
}

const isValidPromotionalCode = ({}, promotional_code) => {
    return new Promise((resolve, reject)=> {
        let url = 'is_valid_promotional_code/?promotional_code=' + encodeURIComponent(promotional_code);
        client.get(url).then(resp => {
            resolve(resp.data['is_valid']);
        }).catch(err => {
            console.debug(err);
            reject();
        })
    });
}

const emitPaymentSignal = ({}) => {
    return new Promise((resolve, reject) => {
        client.post('emit_payment_signal/').then(() => {
            resolve();
        }).catch(err => {
            console.debug(err);
            reject();
        });
    });
}

const emitPaymentErrorSignal = ({}) => {
    return new Promise((resolve, reject) => {
        client.post('emit_payment_signal_error/').then(() => {
            resolve();
        }).catch(err => {
            console.debug(err);
            reject();
        });
    });
}

const actions = {
    getContractTypes,
    createContract,
    upgradeContract,
    upgradeTrialContract,
    isTransactionOk,
    isValidPromotionalCode,
    emitPaymentSignal,
    emitPaymentErrorSignal,
    setServicePlan,
    setPromotionalCode
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}